module.exports = __webpack_public_path__ + "static/media/howitworks-3.0d57e769.jpg";